/**
 * Version affichée en pied de page.
 *
 * Source unique : les `package.json` du dépôt ne sont jamais publiés, leur
 * champ `version` ne sert donc à rien et diverge au premier oubli. À
 * incrémenter ici, et seulement ici, à chaque nouveauté visible.
 *
 * Le troisième nombre suffit : rien n'est publié ni consommé par un tiers, donc
 * rien ne distingue une nouveauté d'une correction du point de vue d'un
 * appelant. La série reste en 0.1.x tant que l'app n'a pas de raison d'annoncer
 * une rupture.
 *
 * 0.1.5 — partage de la semaine en image, au format story.
 * 0.1.4 — notifications : état « service worker inactif » et précache tolérant.
 * 0.1.3 — saisie anticipée ouverte à quinze jours.
 * 0.1.2 — saisie anticipée du lendemain, lecture d'un jour revue sur mobile.
 * 0.1.0 — première version déployée.
 */
export const APP_VERSION = '0.1.5';
